module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-double-height-living-960-e35a6c58.jpg";